/**
 * @generated SignedSource<<9b3c6ef6564ff8ccbb4781d461783de1>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type Country = "CH" | "DE";
export type Gender = "FEMALE" | "MALE" | "OTHER" | "UNKNOWN";
import { FragmentRefs } from "relay-runtime";
export type patientTableContainerDESearchableQuery$data = {
  readonly patients: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly birthDate: string;
        readonly city: string | null;
        readonly compulsoryHealthInsuranceCardNumber: string | null;
        readonly compulsoryInsureeNumber: string | null;
        readonly compulsoryOrganisationName: string | null;
        readonly compulsoryPolicyNumber: string | null;
        readonly country: Country;
        readonly displayId: number;
        readonly firstName: string | null;
        readonly gender: Gender;
        readonly highlights: ReadonlyArray<{
          readonly key: string;
          readonly value: string;
        }> | null;
        readonly isPotentialDuplicate: boolean;
        readonly lastContactAt: string | null;
        readonly lastName: string | null;
        readonly patientId: string;
        readonly phoneNumber: string | null;
        readonly postalCode: string | null;
        readonly searchScore: number | null;
        readonly street: string | null;
        readonly supplementary1HealthInsuranceCardNumber: string | null;
        readonly supplementary1InsureeNumber: string | null;
        readonly supplementary1OrganisationName: string | null;
        readonly supplementary1PolicyNumber: string | null;
        readonly supplementary2HealthInsuranceCardNumber: string | null;
        readonly supplementary2InsureeNumber: string | null;
        readonly supplementary2OrganisationName: string | null;
        readonly supplementary2PolicyNumber: string | null;
        readonly supplementary3HealthInsuranceCardNumber: string | null;
        readonly supplementary3InsureeNumber: string | null;
        readonly supplementary3OrganisationName: string | null;
        readonly supplementary3PolicyNumber: string | null;
      };
    }> | null;
    readonly totalCount: number;
  } | null;
  readonly " $fragmentType": "patientTableContainerDESearchableQuery";
};
export type patientTableContainerDESearchableQuery$key = {
  readonly " $data"?: patientTableContainerDESearchableQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"patientTableContainerDESearchableQuery">;
};

import DePatientSearchPaginationQuery_graphql from './DePatientSearchPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "patients"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "patientSearchInput"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*:: as any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*:: as any*/)
      },
      "fragmentPathInResult": [],
      "operation": DePatientSearchPaginationQuery_graphql
    }
  },
  "name": "patientTableContainerDESearchableQuery",
  "selections": [
    {
      "alias": "patients",
      "args": [
        {
          "kind": "Variable",
          "name": "patientSearchInput",
          "variableName": "patientSearchInput"
        }
      ],
      "concreteType": "PatientSearchResultConnection",
      "kind": "LinkedField",
      "name": "__DePatientSearchFragment_patients_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PatientSearchResultEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PatientSearchResult",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "patientId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "country",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "firstName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lastName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "birthDate",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "displayId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "phoneNumber",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "city",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "street",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "postalCode",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "gender",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "compulsoryOrganisationName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "compulsoryHealthInsuranceCardNumber",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "compulsoryPolicyNumber",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "compulsoryInsureeNumber",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "supplementary1OrganisationName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "supplementary1HealthInsuranceCardNumber",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "supplementary1PolicyNumber",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "supplementary1InsureeNumber",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "supplementary2OrganisationName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "supplementary2HealthInsuranceCardNumber",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "supplementary2PolicyNumber",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "supplementary2InsureeNumber",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "supplementary3OrganisationName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "supplementary3HealthInsuranceCardNumber",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "supplementary3PolicyNumber",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "supplementary3InsureeNumber",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isPotentialDuplicate",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lastContactAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "KeyValuePairOfStringAndString",
                  "kind": "LinkedField",
                  "name": "highlights",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "key",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "value",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "searchScore",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "652e676e0f9055b1bbaa0faa086049c3";

export default node;
